import cijo from "../assets/images/cijo.png";
import alvin from '../assets/images/alvin.png'
import akash from '../assets/images/akash.png'
import mathew from '../assets/images/mathew.png'
import laya from '../assets/images/laya.jpg'
import aswathy from '../assets/images/aswathy.jpg'
export const contactsData = [
    {
      id: 1,
      name: "Mathew Davis",
      designation: "Chairperson",
      image: mathew,
      phone: "+919496573224",
      email: "mathewdavis.mec@gmail.com",
      linkedIn: "https://www.linkedin.com/in/mathew-davis-855002211/",
    },
    {
      id: 2,
      name: "Cijo Jose",
      designation: "Social Initiatives Manager",
      image: cijo,
      phone: "9496993697",
      email: "cijojose.mec@gmail.com",
      linkedIn: "https://www.linkedin.com/in/cijo-jose-01b59425a/",
    },

    {
      id: 3,
      name: "Alvin John Mathew",
      designation: "Event Head",
      image: alvin,
      phone: "+919188676318",
      email: "alvinjohnmathew@gmail.com",
      linkedIn: "https://www.linkedin.com/in/alvin-john-mathew-a93a2b253/",
    },
    {
      id: 4,
      name: "Aswathy Vijayan",
      designation: "Event Head",
      image: aswathy,
      phone: "+916235386050",
      email: "aswathyvijayanck.mec@gmail.com",
      linkedIn: "https://www.linkedin.com/in/aswathy-vijayan-0712a5202/",
    },
    {
      id: 5,
      name: "Akash VP",
      designation: "Event Head",
      image: akash,
      phone: "+919633776062",
      email: "akashvp40@gmail.com",
      linkedIn: "https://www.linkedin.com/in/akash-vp-5767721b0",
    },
    {
      id: 6,
      name: "Laya Sara Joy",
      designation: "Event Head",
      image: laya,
      phone: "+919446438309",
      email: "layasara2727@gmail.com",
      linkedIn: "https://www.linkedin.com/in/laya-sara-joy-ba8a70257/",
    },

   
]